import simbApi from ".";
import { COLLATED_UPDATES } from "../../data/constants/endpoints";
import { CollatedUpdatesResponse } from "../../types/collatedUpdates";

export const getCollatedUpdates = async (
  itemId: string,
  page: number,
  scope: "updates" | "all" = "updates",
): Promise<CollatedUpdatesResponse> => {
  const response = await simbApi.get(COLLATED_UPDATES, { params: { itemId, page, scope } });
  return response.data?.data ?? { entries: [], page, hasMore: false };
};
